// extracted by mini-css-extract-plugin
module.exports = {"ledeVideo":"ledeVideo_ledeVideo__MkrSN"};